import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainContext from '../../../context/mainContext';
import { charsNormalize } from '../../../util/charactorsNormalize';
import { sendMobileNumber, sendVerificationCode } from '../../../service/userService';
import toast from 'react-hot-toast';
import { getBrowserSession } from '../../../util/fingerPrint';

const LoginPage2 = ({ setPage, mobileNumberRef, remainingTimeRef, closeLoginModal }) => {

    const regix = /^[0-9]{6}$/;
    const [isLoading, setIsLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const textInputRef = useRef(null);
    const [verificationCode, setverificationCode] = useState('');
    const [countWrong, setCountWrong] = useState(false);
    const navigate = useNavigate();

    const context = useContext(MainContext)

    const executeTime = (soconds) => {
        return {
            minutes: Math.floor(soconds / 60),
            seconds: soconds % 60
        }
    }

    const [time, setTime] = useState({
        minutes: executeTime(remainingTimeRef.current).minutes,
        seconds: executeTime(remainingTimeRef.current).seconds,
    })


    const clickRef = useRef(null);

    useEffect(() => {
        const timer = setInterval(() => {
            let newTime = executeTime(remainingTimeRef.current)
            setTime({
                seconds: newTime.seconds,
                minutes: newTime.minutes
            })

            remainingTimeRef.current -= 1;
        }, 1000);
        return () => { clearInterval(timer) };
    }, [remainingTimeRef]);


    const getCodeAgain = async () => {
        try {
            setResendLoading(true);
            const { status, data } = await sendMobileNumber(mobileNumberRef.current);
            if (status === 201) {
                remainingTimeRef.current = Math.floor(data.remainingSeconds);
                setResendLoading(false);
                setCountWrong(false);
                setverificationCode('');
                setIsValid(false);
                textInputRef.current.focus();
            }
        } catch (err) {

        }

    }

    const submitHandler = async (event) => {
        try {
            event.preventDefault();
            if (isValid) {
                setIsLoading(true);
                const params = {
                    mobile: mobileNumberRef.current,
                    vCode: verificationCode,
                    session: JSON.stringify(getBrowserSession())
                }
                const { status, data } = await sendVerificationCode(params);
                if (status === 201) {
                    if (data.message === 'Logged in!') {
                        localStorage.setItem('token', data.token);
                        context.login(data.user);
                        toast.success('ورود با موفقیت انجام شد')
                        closeLoginModal();
                        window.innerWidth < 992 && navigate('/account-menu')
                    }
                    else {
                        setPage('3');
                    }
                }
            }

        } catch (err) {
            if (err.response && err.response.status === 429) {
                setCountWrong(true);
                setIsLoading(false);
                toast.error("سقف تعداد ورود مجاز")
            }
            else if (err.response && err.response.status === 404) {
                setIsLoading(false);
                toast.error("زمان مجاز به اتمام رسیده است")
                setverificationCode('');
                setIsValid(false);
            }
            else if (err.response && err.response.status === 401) {
                setIsLoading(false);
                toast.error("کد تایید اشتباه است")
                setverificationCode('');
                setIsValid(false);
            }
        }
    }

    const getStatusOfInput = () => {
        if (isValid) {
            return 'form-control text-center mx-auto is-valid'
        }
        else {
            return 'form-control text-center mx-auto is-invalid'
        }

    }

    useEffect(() => {
        textInputRef.current && textInputRef.current.focus();
    }, []);

    return (
        <div>
            <form onSubmit={submitHandler}>
                <div className=" mb-3 mt-2">
                    <p className="text-center ltr">
                        <span className="text-dark" style={{ fontSize: '1.2rem' }}>
                            <i className="fa fa-envelope-o text-dark ms-2">
                            </i>
                            {mobileNumberRef.current}</span>
                    </p>
                    <div className="text-center mb-2">
                        <span className="text-success">
                            کد تایید با پیامک برای شما ارسال شد
                        </span>
                    </div>
                    <input
                        type="tel"
                        autoComplete="off"
                        style={{ direction: 'ltr', width: '220px' }}
                        className={getStatusOfInput()}
                        ref={textInputRef}
                        id="verificationCode"
                        name="verificationCode"
                        placeholder="کد تایید 6 رقمی"
                        value={verificationCode}
                        onChange={(e) => {
                            if (regix.test(charsNormalize(e.target.value)))
                                setIsValid(true);
                            else
                                setIsValid(false);
                            setverificationCode(charsNormalize(e.target.value));

                        }}
                        onBlur={() => {
                            if (verificationCode !== '') {

                            }
                        }}
                    />
                </div>
                <section className="mt-2 mb-4">
                    <div className="text-center ">
                        <button
                            ref={clickRef}
                            type="submit"
                            className="btn btn-success mx-auto d-flex justify-content-center align-items-center"
                            style={{ width: '140px' }}
                            disabled={(time.minutes <= 0 && time.seconds <= 0) || countWrong || isLoading || !isValid}
                        >
                            {
                                isLoading &&
                                <i className='spinner-border spinner-border-sm operator-button me-2'
                                ></i>
                            }
                            ورود
                        </button>
                    </div>
                </section>
            </form>
            <div className="text-center pb-3">
                <span className="text-dark mx-auto text-center">
                    {
                        (time.minutes <= 0 && time.seconds <= 0) ?
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-secondary mx-auto d-flex justify-content-center align-items-center"
                                    onClick={getCodeAgain}
                                    disabled={resendLoading}
                                >
                                    {
                                        resendLoading &&
                                        <i className='spinner-border spinner-border-sm operator-button me-2'
                                        ></i>
                                    }
                                    ارسال دوباره
                                    <i className="fa fa-undo ms-2 me-1"></i>
                                </button>
                            </div>
                            :
                            <React.Fragment>
                                <span>{("0" + time.minutes).slice(-2)}</span>
                                <span className="mx-1">:</span>
                                <span>{("0" + time.seconds).slice(-2)}</span>
                            </React.Fragment>
                    }
                </span>
            </div>
        </div>
    );
}

export default LoginPage2;